import { Banner, BannerVariant, Button, ButtonVariants, Form, Modal, ModalSizes } from "@centricsoftware/design-system";
import { CANCEL_RES, SAVE_NEW_RES, SAVE_RES } from "csi/components/constants";
import { useSetRefOnMount } from "csi/components/hooks";
import { getSlotContainerName } from "csi/page/ReactPortals/ReactPortals";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import AttributeDefinitionSectionConfiguration from "./AttributeDefinitionSectionConfiguration";
import AttributeDefinitionSectionCopyOptions from "./AttributeDefinitionSectionCopyOptions";
import AttributeDefinitionSectionExpression from "./AttributeDefinitionSectionExpression";
import AttributeDefinitionSectionInitialValue from "./AttributeDefinitionSectionInitialValue";
import AttributeDefinitionSectionMain from "./AttributeDefinitionSectionMain";
import AttributeDefinitionSectionNotes from "./AttributeDefinitionSectionNotes";
import AttributeDefinitionSectionREST from "./AttributeDefinitionSectionREST";
import AttributeDefinitionSectionValidationExpression from "./AttributeDefinitionSectionValidationExpression";
import { AttributeDefinitionStoreContext } from "./AttributeDefinitionStore";
import { AttributeDefinitionDialogProps } from "./AttributeDefinitionTypes";

const modalContainerName = getSlotContainerName("body");
const modalContainer = () => document.getElementById(modalContainerName);

// TODO: remove className="csi-modal-dialog-z-index-800" after DS change default z-index for modals to 800

const AttributeDefinitionPopup: FunctionComponent<AttributeDefinitionDialogProps> = observer((props) => {
	const { onClickSaveNew, onClose, onSave, store, title, titleRes } = props;
	const { formError, isNew, saveDisabled, setFormRef } = store;
	
	const formRef = useSetRefOnMount<HTMLFormElement>(setFormRef);
	
	return (
		<Modal
			actionButtonProps={{
				childrenRes: SAVE_RES,
				disabled: saveDisabled,
				onClick: onSave,
			}}
			cancelButtonProps={{
				childrenRes: CANCEL_RES,
				onClick: onClose,
			}}
			className="csi-modal-dialog-z-index-800"
			// C8-76259 - https://github.com/mui/material-ui/issues/19450#issuecomment-1539832475
			container={modalContainer}
			dataCsiAutomation="AttributeDefinitionPopup"
			disableEnforceFocus
			footerChildren={isNew && (
				<Button
					childrenRes={SAVE_NEW_RES}
					onClick={onClickSaveNew}
					variant={ButtonVariants.secondary}
				/>
			)}
			onClose={onClose}
			open
			showActionButton
			showCancelButton
			showFooter
			size={ModalSizes.Large}
			title={title}
			titleRes={titleRes}
		>
			<Form isFullWidth ref={formRef}>
				{formError && (
					<Banner
						body={formError}
						variant={BannerVariant.Error}
					/>
				)}
				<AttributeDefinitionStoreContext.Provider value={store}>
					<AttributeDefinitionSectionMain />
					<AttributeDefinitionSectionInitialValue />
					<AttributeDefinitionSectionValidationExpression />
					<AttributeDefinitionSectionExpression />
					<AttributeDefinitionSectionCopyOptions />
					<AttributeDefinitionSectionConfiguration />
					<AttributeDefinitionSectionREST />
					<AttributeDefinitionSectionNotes />
				</AttributeDefinitionStoreContext.Provider>
			</Form>
		</Modal>
	);
});

export default AttributeDefinitionPopup;